import { render, staticRenderFns } from "./TabDesalination.vue?vue&type=template&id=c2078338&"
import script from "./TabDesalination.vue?vue&type=script&lang=js&"
export * from "./TabDesalination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports